export function roundToQuarter(value: number) {
  const decimal = value % 1;
  if (decimal < 0.125) {
    return Math.floor(value);
  }
  if (decimal < 0.375) {
    return Math.floor(value) + 0.25;
  }
  if (decimal < 0.625) {
    return Math.floor(value) + 0.5;
  }
  if (decimal < 0.875) {
    return Math.floor(value) + 0.75;
  }
  return Math.ceil(value);
}

export function roundToHalf(value: number) {
  const decimal = value % 1;
  if (decimal < 0.25) {
    return Math.floor(value);
  }
  if (decimal < 0.75) {
    return Math.floor(value) + 0.5;
  }
  return Math.ceil(value);
}
